<template>
  <div id="page-add-category">
    <vs-card>
      <div class="vx-row pt-5 px-5">
        <div class="vx-col w-full md:w-1/2 px-8">
          <div class="vx-row mb-2">
            <vs-input icon="icon icon-list" v-model="form.category_name" icon-pack="feather" class="w-full" label="Category Name" name="Category Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Category Name')">{{ errors.first('Category Name') }}</span>
          </div>
          <div class="vx-row mb-2">
            <vs-input icon="icon icon-file-text" v-model="form.description" icon-pack="feather" class="w-full" label="Description" name="Description" />
            <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
          </div>
        </div>
      </div>
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button class="mr-2 vs-con-loading__container" id="add-category-button" type="relief" @click="save_changes" :disabled="!validateForm || loading">Save Changes</vs-button>
            <vs-button to="/category/list" color="danger" type="relief" class="text-left">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'EditCategory',
  data() {
    return {
      form: {
        category_name: '',
        description: ''
      }
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.processing = true
    this.getCategoryId(id)
      .then(({ data }) => {
        this.processing = false
        const { productCategory } = data
        this.form.category_name = productCategory.category_name
        this.form.description = productCategory.description
      })
      .catch(err => {
        const { message } = err
        this.processing = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  computed: {
    ...mapState('product', { loading: 'category-loading' }),
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    ...mapActions('product', ['updateCategory', 'getCategoryId']),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }
      try {
        const { message } = await this.updateCategory({
          id: this.$route.params.id,
          data: this.form
        })
        this.$router.push({
          name: 'category-list'
        })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add-category-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-category-button > .con-vs-loading')
      }
    }
  }
}
</script>
